import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import buscarLogsAuditoria from "./services";

interface IParamsGetAuditoria {
  data?: string;
  tipo?: "excecoes" | "auditoria";
  busca?: string;
  pagina?: number;
  itensPorPagina?: number;
}

interface IStateAuditoria {
  logs: any[];
  tipo: "excecoes" | "auditoria";
  paginaAtual: number;
  itensPorPagina: number;
  totalItens: number;
  totalPaginas: number;
  status: "" | "success" | "failed" | "loading";
  feedbackError?: any;
}

export const actionGetLogsAuditoria: any = createAsyncThunk(
  "GET_AUDITORIA_LOGS",
  async (params: IParamsGetAuditoria = {}, { rejectWithValue }) => {
    try {
      const { data } = await buscarLogsAuditoria(params);

      return { ...data, tipo: params.tipo ?? "excecoes" };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

const auditoriaSlice = createSlice({
  name: "AUDITORIA",
  initialState: <IStateAuditoria>{
    logs: [],
    tipo: "excecoes",
    paginaAtual: 1,
    itensPorPagina: 20,
    totalItens: 0,
    totalPaginas: 0,
    status: "",
    feedbackError: "",
  },
  reducers: {
    limparLogs: (state) => {
      state.logs = [];
      state.status = "";
      state.paginaAtual = 1;
      state.totalItens = 0;
      state.totalPaginas = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionGetLogsAuditoria.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(actionGetLogsAuditoria.fulfilled, (state, action) => {
      state.status = "success";
      state.logs = action.payload.itens ?? [];
      state.tipo = action.payload.tipo;
      state.paginaAtual = action.payload.paginaAtual ?? 1;
      state.itensPorPagina = action.payload.itensPorPagina ?? 20;
      state.totalItens = action.payload.totalItens ?? 0;
      state.totalPaginas = action.payload.totalPaginas ?? 0;
      state.feedbackError = "";
    });
    builder.addCase(actionGetLogsAuditoria.rejected, (state, action) => {
      state.status = "failed";
      state.logs = [];
      state.feedbackError = action.payload || "Erro desconhecido";
    });
  },
});

export const { limparLogs } = auditoriaSlice.actions;
export default auditoriaSlice.reducer;
